import { IApplicationState } from '../../types/redux';

export function selectFilterJsonQuery(state: IApplicationState) {
  return state.filterJsonQuery;
}
